import axios from "axios";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";
import Header from "../../Components/Header";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Loader from "../../Components/Common/Loader";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { Client_Search } from "../../Configuration/API_URL";
import { Partner_Reports } from "../../Configuration/Partner_URL";
import {
  AESEncryption,
  ApiResDecrypt,
  compareDate,
  decryptData,
  encryptData,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import { Constants } from "../../CommonMethhods/Constants";
import { useDebounce } from "../../Components/useDebounce";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MtfPosReportTable from "../../Components/ReportTables/MtfPosReportTable";

function MtfPosReportSidebar() {
  const storeToken = localStorage.getItem("ssoToken");
  const userType = localStorage.getItem("partnerType").toLowerCase();
  const [fileType, setFileType] = useState("");
  const [onDate, setOnDate] = useState(moment().format("MM-DD-YYYY"));
  const [clientList, setClientList] = useState([]);
  const [clientCode, setClientCode] = useState("");
  const [loader, setLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [noNameFoundError, setNoNameFoundError] = useState("");
  const [blankClientCodeError, setBlankClientCodeError] = useState("");
  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);
  const [errorResp, setErrorResp] = useState(false);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [page, setPage] = useState(1);
  const [show, setShow] = useState(false);
  const [noReportFound, setNoReportFound] = useState(false);

  const debouncedClientCode = useDebounce(clientCode, 1000);

  useEffect(() => {
    if (debouncedClientCode) {
      searchApiDetail(debouncedClientCode, 1);
      setScrollLoader(true);
      setClientList([]);
      setPage(1);
    }
  }, [debouncedClientCode]);

  useEffect(() => {
    if (page > 1) {
      searchApiDetail(clientCode, page);
    }
  }, [page]);

  useEffect(() => {
    if (fileType) {
        getMtfPosReport();
    }
  }, [fileType]);

  const searchApiDetail = async (code, NoPage) => {
    const payloadValue = {
      keyword: code,
      Status: "",
      PageNo: NoPage,
      PageSize: 10,
    };

    const partnerPayload = {
      clientCode: code,
      page: NoPage,
      pageSize: 10,
    };

    const encPayload =
      userType === "partner"
        ? encryptData(JSON.stringify(partnerPayload))
        : AESEncryption(payloadValue);

    try {
      const response = await axios.post(
        userType === "partner"
          ? Partner_Reports.Client_Search_Partner_URL
          : Client_Search.Search_URL,
        userType === "partner" ? encPayload : `"${encPayload}"`,
        {
          headers: {
            "Content-Type":
              userType === "partner" ? "text/plain" : "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const res =
        userType === "partner"
          ? JSON.parse(decryptData(response?.data))
          : ApiResDecrypt(response?.data);

      if (res?.status === 0) {
        setFileType("");
        setCount(res?.data?.TotalCount);
        setNoNameFoundError("");
        setClientList((prev) =>
          page > 1 ? [...prev, ...res?.data?.clients] : res?.data?.clients
        );
      } else {
        setNoNameFoundError(res?.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setScrollLoader(false);
      setBlankClientCodeError("");
    }
  };

  const getMtfPosReport= async () => {
    setLoader(fileType === "grid");
    setSmallLoaderExcel(fileType === "excel");
    setSmallLoaderPdf(fileType === "pdf");

    const payloadValue = {
      clientCode,
      date: onDate,
      fileType,
    };

    const encPayload =
      AESEncryption(payloadValue);

    try {
      const response = await axios.post(
        Dashboard_Client_Report.MtfPos_Report,
       `"${encPayload}"`,
        {
          headers: {
            "Content-Type":
              userType === "partner" ? "text/plain" : "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const res = ApiResDecrypt(response?.data);
      console.log(res, "cos1234");
      if (res?.data) {
        setNoReportFound(false);
        if (fileType === "grid") {
          setData(res?.data?.posList);
        } else {
          window.open(
            res?.data,
            fileType === "pdf" ? "_blank" : "_self",
            "noopener,noreferrer"
          );
        }
       
      } else {
        if (fileType === "grid") {
          setData([]);
          setNoReportFound(res?.message);
        } else {
          toast.error(res?.message);
        }
      }
    } catch (error) {
      console.error(error);

      if (fileType !== "grid") {
        toast.error(error?.message);
      } else {
        setNoReportFound(error?.message);
        setData([]);
      }
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
    }
  };

  const handleOnDateChange = (e) => {
    setFileType("");
    setErrorResp(false);
    setData([]);
    const date = moment(e.target.value, "YYYY-MM-DD").format("MM-DD-YYYY");
    setOnDate(date);
    setNoReportFound(false);
  };

  const handleOnClick = (e) => {
    const selectedFileType = e.target.value;
    if (clientCode) {
      if (selectedFileType) {
        if (compareDate(onDate)) {
          setFileType(selectedFileType);
        } else {
          setErrorResp("*Please Select Correct Date");
        }
      }
    } else {
      setShow(false);
      setClientList([]);
      setBlankClientCodeError("*Please Enter Client Name/Code");
    }
  };

 

  const handleScroll = async (e) => {
    const element = e.target;
    if (
      element.scrollTop + element.offsetHeight + 1 >= element.scrollHeight &&
      !scrollLoader
    ) {
      if (count > 10 * page) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    }
  };

  return (
    <>
      <Header portal="RM" />
      <SingleSignOnSideBar />
      <main id="main-content" className="reports">
        <div className="card-box">
          <div>
            <h2 className="report-title">{Constants.MTF_POS}</h2>
          </div>
          <div className="row input-field-wrapper">
            <div className="col-md-3 col-sm-3 col-6">
              <div className="form-group">
                <label className="form-label">{Constants.Client_Search}</label>
                <div className="rm-custom-dropdown">
                  <input
                    type="text"
                    className="input-st"
                    placeholder="Search here..."
                    autoComplete="off"
                    value={clientCode}
                    onChange={(e) => {
                      setClientCode(e.target.value.toUpperCase());
                      setShow(true);
                      setNoReportFound(false);
                      setBlankClientCodeError(false);
                    }}
                    onInput={(e) => {
                      const start = e.target.selectionStart;
                      const end = e.target.selectionEnd;
                      let input = e.target.value;
                      input = input
                          .toUpperCase()
                          .replace(/[^A-Z0-9\s]/g, "")
                          .replace(/\s+/g, " ")
                          .trimStart()
                          .slice(0, 100);

                      e.target.value = input;
                      e.target.setSelectionRange(start, end);
                  }}
                  />
                  <button
                    className="rm-dropdown-btn"
                    onClick={() => setShow(!show)}
                  >
                    <span className="icon-right-arrow-triangle"></span>
                  </button>
                  {show && (
                    <ul
                      className="rm-mapping-ap border-0"
                      onScroll={handleScroll}
                    >
                      {clientList.map((item, i) => (
                        <li
                          key={i}
                          className="rm-maping-item-wrapper"
                          onClick={() => {
                            setClientCode(item?.clientCode);
                            setShow(false);
                          }}
                        >
                          {userType === "partner" ? 
                                <>
                                  <div> {item?.clientName}</div>
                                  <div> {item?.clientCode}</div>
                                </>
                              : 
                                <>
                                  <div> {item?.clientname}</div>
                                  <div> {item?.clientCode}</div>
                                </>
                              }
                        </li>
                      ))}
                      {scrollLoader && !loader && (
                        <div className="loader-center">
                          <LoaderForSearch />
                        </div>
                      )}
                      {noNameFoundError && !scrollLoader && (
                        <li
                          className="rm-maping-item-wrapper"
                          style={{ borderBottom: "none", fontSize: "12px" }}
                        >
                          {noNameFoundError}
                        </li>
                      )}
                    </ul>
                  )}
                </div>
                {blankClientCodeError && (
                  <span className="to-date-error">{blankClientCodeError}</span>
                )}
              </div>
            </div>
            <div className="col-md-4 col-sm-4 col-6">
              <div className="form-group calendar-icon">
                <label className="form-label">{Constants.As_On_Date}</label>
                <input
                  type="date"
                  max={moment().format("YYYY-MM-DD")}
                  value={moment(onDate, "MM-DD-YYYY").format("YYYY-MM-DD")}
                  className="OnDate form-control"
                  onChange={handleOnDateChange}
                />
                <span className="to-date-error">{errorResp}</span>
                <span className="icon-calendar ico"></span>
              </div>
            </div>
          </div>

          <div className="text-center search-btn-wrapper">
            <button
              value="grid"
              className="send-message"
              onClick={handleOnClick}
            >
              {Constants.Search}
            </button>
          </div>

          <div>
            <ReportTableHeader
              smallLoaderExcel={smallLoaderExcel}
              smallLoaderPdf={smallLoaderPdf}
              handleOnClick={handleOnClick}
            />
          </div>
          <div className="for-grid-section">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : data && data.length > 0 ? (
            <MtfPosReportTable data={data}/>
            ) : (
              noReportFound && (
                <h4 className="report-error-message">
                  {noDataFound(noReportFound)}
                </h4>
              )
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default MtfPosReportSidebar;
